import React from "react";
import { Link } from "react-router-dom";
import { ASSETS, BRAND } from "@/lib/constants";

export const Logo = ({ className = "", imgClassName = "", withWordmark = false, to = "/" }) => {
  return (
    <Link to={to} className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo" aria-label="CLAWNET home">
      <img
        src={ASSETS.logo}
        alt="CLAWNET"
        className={`object-contain ${imgClassName || "h-9 w-auto"}`}
        style={{ maxWidth: "100%" }}
      />
      {withWordmark && (
        <span className="font-heading text-xl font-extrabold tracking-tight text-white sr-only">{BRAND.name}</span>
      )}
    </Link>
  );
};

export default Logo;
